import(/* webpackMode: "eager", webpackExports: ["FeedbackPageClient"] */ "/workspace/.ci/web-hosting-src/app/feedback/FeedbackPageClient.tsx");
